document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.lmaModalsInitialized === 'undefined') {
    window.lmaModalsInitialized = true;
    window.openLmaModal = function (modalId) {
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add('is-active');
        const body = document.body;
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        const originalPaddingRight = window.getComputedStyle(body).paddingRight;

        body.dataset.paddingRight = originalPaddingRight;
        body.style.paddingRight = `${parseInt(originalPaddingRight || 0) + scrollbarWidth}px`;
        body.style.overflow = 'hidden';
        // Custom event for modal open
        try {
          const evt = new CustomEvent('lma:modal:open', { detail: { modalId } });
          window.dispatchEvent(evt);
        } catch (e) {}
      }
    };
    window.closeLmaModal = function (modalId) {
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.remove('is-active');
        const body = document.body;
        body.style.paddingRight = body.dataset.paddingRight || '';
        body.style.overflow = '';
        delete body.dataset.paddingRight;
        // Custom event for modal close
        try {
          const evt = new CustomEvent('lma:modal:close', { detail: { modalId } });
          window.dispatchEvent(evt);
        } catch (e) {}
      }
    };
    setupModalLinks();
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.lma-modal.is-active').forEach((modal) => {
          window.closeLmaModal(modal.id);
        });
      }
    });
  }
  function setupModalLinks() {
    const links = document.querySelectorAll('a[href^="#modal:"]');
    links.forEach((link) => {
      const href = link.getAttribute('href');
      const modalId = 'lma-modal-' + href.split('#modal:')[1];
      link.addEventListener('click', function (e) {
        e.preventDefault();
        openLmaModal(modalId);
      });
    });
  }
});